import React from 'react';
import { Box, Typography, useMediaQuery } from '@mui/material';
import SlideIn from './shared/slide/SlideIn';
import { useTheme } from '@mui/material/styles';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'; // Simple bullet icon

const reasons = [
    { id: 1, text: 'Cheapest Rate In Town' },
    { id: 2, text: 'Minimal Security Deposit of ₹3000' },
    { id: 3, text: 'Convenient Airport Pick-Up & Drop-Off with Minimal Charges' },
    { id: 4, text: 'Luxury Cars Available On Demand' },
    { id: 5, text: 'Well Maintained Cars' },
    { id: 6, text: 'No Third Party Mess' },
    { id: 7, text: 'Transparent Pricing with No Hidden Fees' },
  ];

const WhyUs = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box sx={{ padding: '0px' }}>
      {/* Heading */}
      <Typography variant="h3" component="h2" fontWeight="bold" sx={{ mb: 3, textAlign:'center' }}>
        Why Us
      </Typography>

      {/* Simple Responsive Bulleted List */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '16px', // Space between each list item
          alignItems: 'flex-start',
          maxWidth: '600px',
          margin: '0 auto',
          paddingX: '16px',
        }}
      >
        {reasons.map((reason) => (
          <SlideIn key={reason.id} direction="right">
            <Box sx={{ display: 'flex', alignItems: 'left', gap: '8px' }}>
              <FiberManualRecordIcon
                sx={{
                  fontSize: '16px',
                  color: 'black',
                  marginTop:isSmallScreen?'5px':'10px'
                }}
              />
              <Typography
                variant={isSmallScreen ? 'body1' : 'h6'}
                color="text.primary"
                sx={{ fontWeight: 500 }}
              >
                {reason.text}
              </Typography>
            </Box>
          </SlideIn>
        ))}
      </Box>
    </Box>
  );
};

export default WhyUs;
